<template>
  <TabGroup :default-index="defultActiveIndex ? defultActiveIndex : 0" @change="onChange">
    <TabList
      class="box-border flex h-10 justify-center gap-1 rounded-xl bg-gray-800 p-1 w-fit min-w-full"
    >
      <Tab
        v-for="option in options"
        :key="option.value"
        v-slot="{ selected }"
        v-tooltip="{ content: option.tooltip }"
        as="div"
        class="flex focus:outline-none"
        :class="{
          'w-full': !noWFull,
        }"
      >
        <button
          :disabled="option.disabled"
          :data-testid="'button-' + option.value"
          :class="[
            'w-full rounded-lg font-inter text-xs font-medium leading-5 text-gray-100 transition duration-300 whitespace-nowrap px-2.5',
            selected
              ? 'bg-gray-600 text-gray-50 outline outline-2 outline-offset-[-2px] outline-accent-1'
              : 'cursor-pointer bg-gray-800 text-gray-100 hover:bg-gray-600 hover:text-gray-50',
            option.disabled ? '!cursor-default !bg-gray-800 !text-gray-100' : '',
          ]"
        >
          <slot :item="option">{{ option.name }}</slot>
        </button>
      </Tab>
    </TabList>
  </TabGroup>
</template>

<script setup lang="ts">
import { TabGroup, TabList, Tab } from "@headlessui/vue";

interface Option {
  name: string;
  value: string;
  disabled?: boolean;
  tooltip?: string;
}

defineProps<{
  options: Option[];
  defultActiveIndex?: number;
  noWFull?: boolean;
}>();

const emit = defineEmits<{
  (e: "onTabChange", index: number): void;
}>();

function onChange(index: number) {
  emit("onTabChange", index);
}
</script>
